import { useGetApiProfileQuery } from "@shared/api";

export const useUserProfile = () => {
  const { data: profile, isLoading, error } = useGetApiProfileQuery();

  const isProfileCompleted = Boolean(
    profile?.data.name ||
      profile?.data.description ||
      profile?.data.birth_date ||
      (profile?.data.skills && profile.data.skills.length > 0) ||
      (profile?.data.interests && profile.data.interests.length > 0)
  );

  const areAllFieldsFilled = Boolean(
    profile?.data.name &&
      profile?.data.description &&
      profile?.data.birth_date &&
      profile?.data.skills &&
      profile?.data.skills.length > 0 &&
      profile?.data.interests &&
      profile?.data.interests.length > 0
  );

  const getUnfilledFieldsMessage = () => {
    if (!profile?.data) return "Профиль не загружен";

    const unfilledFields = [];

    if (!profile.data.name) unfilledFields.push("Имя");
    if (!profile.data.description) unfilledFields.push("О себе");
    if (!profile.data.birth_date) unfilledFields.push("Дата рождения");
    if (!profile.data.skills?.length) unfilledFields.push("Навыки");
    if (!profile.data.interests?.length) unfilledFields.push("Интересы");

    if (unfilledFields.length === 0) return "Все поля заполнены";

    return `Не заполнены поля: ${unfilledFields.join(", ")}`;
  };

  return {
    isProfileCompleted,
    areAllFieldsFilled,
    isLoading,
    error,
    unfilledFieldsMessage: getUnfilledFieldsMessage(),
  };
};
